'use client'
import { ControllerRenderProps } from 'react-hook-form'
import { FormControl } from '../form/form'
import { Input } from '@/components/ui/input/input'

export const EmailInput = ({
  field,
  transactionName,
}: {
  field: ControllerRenderProps
  /**
   * Transaction name for RUM monitoring.
   * Required for observability - tracks user interactions in Elastic APM.
   * Format: area.page.field_name (e.g., "forms.fd02.email")
   */
  transactionName: string
}) => {
  return (
    <FormControl>
      <Input type="email" {...field} transactionName={transactionName} />
    </FormControl>
  )
}
